exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bull-left[data-v-38c04942]{grid-area:bull-left}.bull-bottom[data-v-38c04942]{grid-area:bull-bottom;display:flex;align-self:center;justify-self:center}.bull-right[data-v-38c04942]{grid-area:bull-right}#modal-leg-end .results[data-v-38c04942]{font-size:3vw;justify-content:center}.modal-button[data-v-38c04942]{font-size:2vw;margin-top:1vw}.modal-footer[data-v-38c04942]{display:none!important}", ""]);

// exports
